// Schema Index - Central registry for all listing type schemas
import productSchema from './productSchema.json';
import serviceSchema from './serviceSchema.json';
import rentalSchema from './rentalSchema.json';
import eventSchema from './eventSchema.json';
import classifiedSchema from './classifiedSchema.json';
import subscriptionSchema from './subscriptionSchema.json';
import volunteeringSchema from './volunteeringSchema.json';
import catalogSchema from './catalogSchema.json';

// Map category URL params to schemas
export const schemas = {
  product: productSchema,
  products: productSchema,
  service: serviceSchema,
  services: serviceSchema,
  rental: rentalSchema,
  rentals: rentalSchema,
  event: eventSchema,
  events: eventSchema,
  classified: classifiedSchema,
  classifieds: classifiedSchema,
  subscription: subscriptionSchema,
  subscriptions: subscriptionSchema,
  volunteering: volunteeringSchema,
  catalog: catalogSchema,
  catalogs: catalogSchema,
};

// Get schema by category
export const getSchema = (category) => {
  if (!category) return null;
  const normalizedCategory = category.toLowerCase().replace(/s$/, ''); // Remove trailing 's'
  return schemas[normalizedCategory] || schemas[category?.toLowerCase()] || null;
};

// Get all available categories
export const getAvailableCategories = () => [
  'product', 'service', 'rental', 'event', 'classified', 'subscription', 'volunteering', 'catalog'
];

// Get category display info
export const getCategoryInfo = () => {
  return Object.entries({
    product: productSchema,
    service: serviceSchema,
    rental: rentalSchema,
    event: eventSchema,
    classified: classifiedSchema,
    subscription: subscriptionSchema,
    volunteering: volunteeringSchema,
    catalog: catalogSchema,
  }).map(([key, schema]) => ({
    key,
    title: schema.title,
    listingType: schema.listingType,
    redirectPath: schema.redirectPath,
  }));
};

// Get default values for a category
export const getDefaultValues = (category) => {
  const schema = getSchema(category);
  return schema?.defaultValues || {};
};

// Get features for a category
export const getFeatures = (category) => {
  const schema = getSchema(category);
  return schema?.features || {};
};

// Get validation rules for a category
export const getValidationRules = (category) => {
  const schema = getSchema(category);
  return schema?.validation || {};
};

export default schemas;
